import { isNil } from "./ramdaEquivalents.utils";

export const toLowerCase = (s: string) => isNil(s) ? '' : s.toLowerCase();
